module.exports = __webpack_public_path__ + "static/media/HandsLandingImage-min.f8539608.jpeg";